import { ArrowRight, Compass } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { SoteriaCard, soteriaCardCtaClass } from './SoteriaCard';
import { useSoteriaSidePanelStore } from '../stores/sidePanelStore';
import type { NavigateCard as NavigateCardData } from '../hooks/useSoteriaChat';

/**
 * NavigateCard
 * ------------
 * Soteria's "take me there" hand-off. The agent proposes a destination; the
 * ADVISOR clicks to go. Never auto-navigates — the assistant must not yank
 * someone off the screen they're working on. The path comes from the backend's
 * fixed destination catalog (tools/navigation.py), not from free text.
 */
export function NavigateCard({ card }: { card: NavigateCardData }) {
  const navigate = useNavigate();
  const closePanel = useSoteriaSidePanelStore((s) => s.close);

  const go = () => {
    // Full-page destinations (e.g. the account-opening wizard) take over the
    // viewport, so close the drawer behind us — matches AccountDraftCard.
    closePanel();
    void navigate({ to: card.path });
  };

  return (
    <SoteriaCard
      variant="default"
      icon={<Compass className="h-4 w-4" />}
      eyebrow="Go to"
      title={card.label}
      cta={
        <button
          type="button"
          onClick={go}
          className={soteriaCardCtaClass('default')}
        >
          Open
          <ArrowRight className="h-3 w-3" />
        </button>
      }
    />
  );
}
